import { Button, Grid, InputAdornment, Select, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const FilterCont = styled(Grid)(({ theme }) => ({
  // backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
  gap: 5,
  '& .MuiOutlinedInput-input': {
    padding: 0,
    background: 'transparent',
  },
  '& .MuiTypography-root': {
    fontSize: 14,
  },
  paddingRight: 5,
  '& .MuiListItem-button:hover': {
    background: `${theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BACKGROUND} !important`,
  },
}));

export const AgeRangeCont = styled('div')(({ theme }) => ({
  minWidth: 240,
  padding: 10,
  borderRadius: 5,
  '& .MuiSelect-iconOutlined': {
    right: '0',
    top: '20px',
  },

  '& .MuiSelect-iconOpen': {
    top: '0px',
    right: '13px',
  },

  '& .MuiOutlinedInput-input': {
    padding: '10px 14px',
  },
}));

export const AgeRangeButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: 40,
  borderRadius: 4,
  // border: `1px solid #c0c0c0`,
  color: COLORS.PRIMARY,
  fontSize: 14,
  fontWeight: 500,
  textTransform: 'capitalize',
  justifyContent: 'space-between',
  padding: '0 0 0 15px',
  background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
  [theme.breakpoints.down('md')]: {
    background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
  },
  //remove hover effect
  '&:hover': {
    background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.JOBS_BG,
  },
}));

export const CustomInputAdornment = styled(InputAdornment)(({ theme }) => ({
  '& p': {
    fontSize: 14,
    color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
    backgroundColor: 'transparent',
  },
}));

export const FilterSelect = styled(Select)(({ theme }) => ({
  background: theme.palette.type === 'dark' ? `${COLORS.DARK_BACKGROUND} !important` : COLORS.JOBS_BG,
  height: 40,
  flex: 1,
  paddingLeft: 0,
  border: '0px solid red',
  //.MuiOutlinedInput-notchedOutline
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  position: 'relative',
}));
